import React from 'react'
import { Collapse } from 'reactstrap'
import { getStaticImage } from 'utils/statics'
import { I18n } from 'react-redux-i18n'

/**
 * Container
 * @param {object} props
 * @param {String} props.title
 * @param {any} props.children
 */
const Container = (props) => {
  const { isOpen, setIsOpen, type, children } = props

  const toggleContainer = () => {
    if (type === 'configuration') {
      setIsOpen({
        configuration: true,
        messages: false,
        resources: false
      })
    }
    if (type === 'messages') {
      setIsOpen({
        configuration: false,
        messages: true,
        resources: false
      })
    }
    if (type === 'resources') {
      setIsOpen({
        configuration: false,
        messages: false,
        resources: true
      })
    }
  }

  return (
    <div className='channel-field container'>
      <div className='header' onClick={toggleContainer}>
        <img className={`${isOpen ? 'rotate' : ''}`} src={`${getStaticImage('/icons/orange-brand/icon-chveron-right.svg')}`} alt='arrow-icon'/>
        <strong>{I18n.t(`channels_container_${type}`)}</strong>
      </div>
      <Collapse isOpen={isOpen}>
        {children}
      </Collapse>
    </div>
  )
}

export default Container
